import { AlertType, AlertWithIllustration } from "Components/Form/Alert";
import {
  hasNotSelectedCoverage,
  toggleProfessionalDisabilityCoverage,
} from "../akaFamilyAccidentUtils";

import { Icons } from "@storebrand-digital/insurance-definitions";
import { H3 } from "App/global-style";
import { Checkbox } from "Components/Form/Checkbox";
import { useTexts } from "Components/TextContext";
import { FormikProps } from "formik";
import React from "react";
import { AkaFamilyAccidentProductIntroFormValues } from "./akaFamilyAccidentProductIntroInterfaces";
import { CoverageCheckboxes } from "./styled";

interface Props {
  formProps: FormikProps<AkaFamilyAccidentProductIntroFormValues>;
}

export const AkaFamilyAccidentProductIntroFormElements = (
  props: Props,
): React.ReactElement => {
  const { formProps } = props;
  const { getText } = useTexts();

  return (
    <>
      <H3>{getText("akafamilyaccidentform.pageheader.introstep")}</H3>
      <p>{getText("akafamilyaccidentform.productintro.info-1")}</p>
      <CoverageCheckboxes>
        <Checkbox
          id="hasDeathCoverage"
          name="hasDeathCoverage"
          label={getText("akafamilyaccidentform.label.hasdeathcoverage")}
        />
        <Checkbox
          id="hasDisabilityCoverage"
          name="hasDisabilityCoverage"
          label={getText("akafamilyaccidentform.label.hasdisabilitycoverage")}
          onChange={(e) =>
            toggleProfessionalDisabilityCoverage(e.target.checked, formProps)
          }
        />
        {formProps.values.hasDisabilityCoverage && (
          <Checkbox
            id="hasProfessionalDisabilityCoverage"
            name="hasProfessionalDisabilityCoverage"
            label={getText(
              "akafamilyaccidentform.label.hasprofessionaldisabilitycoverage",
            )}
          />
        )}
      </CoverageCheckboxes>
      {hasNotSelectedCoverage(formProps) && (
        <AlertWithIllustration
          iconName={Icons.ACCIDENT}
          title={getText("akafamilyaccidentform.alerttitle.nocoverage")}
          alertType={AlertType.INPUT_ERROR_ALERT}
          description={getText(
            "akafamilyaccidentform.alertdescription.nocoverage",
          )}
          marginBottom="32px"
        />
      )}
    </>
  );
};
